// src/components/Contact.js
import React from 'react';
import { Icons } from './Icons';

function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-text">
            <h2>Готовы улучшить свой чат?</h2>
            <p>Добавьте Atri Bot в ваш Telegram-чат и начните пользоваться всеми возможностями уже сегодня.</p>
            <div className="contact-buttons">
              <a href="https://t.me/AtriGuard_bot" className="btn-primary">
                <Icons.Telegram />
                Добавить бота
              </a>
              <a href="https://atri-bot.online" className="btn-secondary">
                <Icons.ExternalLink />
                Онлайн-панель
              </a>
              <a href="https://t.me/littlebigcoder" className="btn-secondary">
                <Icons.MessageSquare />
                Разработчик
              </a>
            </div>
          </div>
          <div className="contact-features">
            <div className="contact-feature">
              <Icons.Check />
              <span>Полностью бесплатно</span>
            </div>
            <div className="contact-feature">
              <Icons.Zap />
              <span>Мгновенная настройка</span>
            </div>
            <div className="contact-feature">
              <Icons.Shield />
              <span>Надёжная защита</span>
            </div>
            <div className="contact-feature">
              <Icons.Users />
              <span>Доступно на всех устройствах</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;